/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Icon,
  Input,
  Switch,
  Modal,
  Row,
  Select,
  Table,
  Tabs,
  message,
} from 'antd'
import styled from 'styled-components'
import {
  deleteWind2TemplateGroup,
  getWind2Entity,
  getWind2TemplateGroups,
  saveWind2TemplateGroup,
  wind2AllPlant,
  wind2AllSubgroup,
} from 'api/pgads'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { getApiTargetInfo } from 'core'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  wind2Report,
  wind2ReportExportBlob,
  wind2ReportGetElements,
} from './wind2api'
import numeral from 'numeral'
import { toXlsxData, writeToExcel } from 'core/component/xlsx-utils-excel'
import { saveAs } from 'file-saver'

const Label = styled.span`
  display: ${props => (props.inline ? 'inline' : 'block')};
  margin-bottom: 5px;
  font-weight: 600;
`

export const ReportIcon = ({ type, disabled, toolTip, onClick }) => (
  <span
    title={toolTip}
    style={{
      cursor: disabled ? 'not-allowed' : 'pointer',
      alignSelf: 'center',
    }}
    onClick={!disabled ? onClick : null}
  >
    <Icon
      type={type}
      theme={`${disabled ? '' : 'twoTone'}`}
      style={{ marginLeft: 5, fontSize: 20, verticalAlign: 'middle' }}
    />
  </span>
)

export const NewGroupModal = ({ onOk, onCancel, placeholder }) => {
  const [name, setName] = useState('')
  return (
    <Modal
      title="Save to New Group"
      width="300px"
      visible
      onOk={name ? () => onOk(name) : null}
      okText="Done"
      onCancel={onCancel}
      centered
      maskClosable={false}
    >
      <Label>New group name</Label>
      <Input
        placeholder={placeholder}
        value={name}
        onChange={e => setName(e.target.value)}
      />
    </Modal>
  )
}

export const LabelWithCustomSelect = ({
  state,
  setterFn,
  type,
  label,
  labelWidth = '100px',
  setPropertyValue,
  setSelectedValue,
  saveDataGroup,
  deleteItemGroup,
  onChange = _ => _,
}) => {
  return (
    <>
      {state.showNewGroupModal && (
        <NewGroupModal
          placeholder="Group Name"
          onOk={newGrpName => {
            setPropertyValue('currentGroup', newGrpName, state, setterFn)
            setPropertyValue('showNewGroupModal', false, state, setterFn)
            saveDataGroup(type, newGrpName, state.selected)
          }}
          onCancel={() =>
            setPropertyValue('showNewGroupModal', false, state, setterFn)
          }
        />
      )}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: labelWidth + ' 200px 20px 20px 20px auto',
          marginBottom: 10,
          alignItems: 'center',
          gridColumnGap: '10px',
          overflowX: 'auto',
        }}
      >
        <Label
          style={{
            fontWeight: 800,
            marginLeft: 5,
            marginTop: 'auto',
            display: 'grid',
            alignContent: 'center',
            height: '100%',
          }}
        >
          {label}
        </Label>
        <Select
          value={state.currentGroup}
          onChange={v => {
            // onChange()
            setPropertyValue('currentGroup', v, state, setterFn)
            if (v !== 'Custom') {
              setSelectedValue(
                state.availableGroups[v].map(g => g.ident),
                state,
                setterFn
              )
            } else {
              setSelectedValue([], state, setterFn)
            }
          }}
        >
          {customOption()}
          {Object.keys(state.availableGroups).map(g => (
            <Select.Option key={g}>{g}</Select.Option>
          ))}
        </Select>
        <ReportIcon
          type="plus-circle"
          toolTip="Save to New Group"
          disabled={!state.selected.length}
          onClick={() =>
            setPropertyValue('showNewGroupModal', true, state, setterFn)
          }
        />
        <ReportIcon
          type="save"
          disabled={!state.selected.length || state.currentGroup === 'Custom'}
          toolTip="Save to Existing Group"
          onClick={() =>
            saveDataGroup(type, state.currentGroup, state.selected)
          }
        />

        <ReportIcon
          type="delete"
          disabled={state.currentGroup === 'Custom'}
          toolTip="Delete Group"
          onClick={_ => deleteItemGroup(state.currentGroup, type)}
        />
      </div>
    </>
  )
}

const sortByProp = prop => R.sortBy(R.prop(prop))
const customOption = () => <Select.Option value="Custom">Custom</Select.Option>
const recordTypeOrder = [
  'RAW',
  'MONTH',
  'SUBGROUP_ID',
  'SUBGROUP_ID_YEAR',
  'PLANT_ID',
  'PLANT_ID_YEAR',
  'PLANT_ID_YEAR_MONTH',
  'YEAR',
  'GRAND',
]
const typeMap = {
  RAW: '',
  MONTH: 'month',
  SUBGROUP_ID: 'subgroup',
  SUBGROUP_ID_YEAR: 'subgroup/year',
  PLANT_ID: 'plant',
  PLANT_ID_YEAR: 'plant/year',
  PLANT_ID_YEAR_MONTH: 'plant/month',
  YEAR: 'year',
  GRAND: 'grand',
}
const title = 'Wind Report'

const Wind2Report = ({ targetInfo }) => {
  const [subgroupList, setSubgroupList] = useState([])
  const [subgroupMap, setSubgroupMap] = useState({})
  const [subGroupsData, setSubGroupsData] = useState({
    selected: [],
    currentGroup: 'Custom',
    availableGroups: {},
    // sortBy: 'D',
  })
  const [calcElementsData, setCalcElementsData] = useState({
    selected: ['ALL'],
    currentGroup: 'Custom',
    availableGroups: {},
    abbreviatedForm: false,
  })
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const [data, setData] = useState([])
  const onChange = _ => {
    setData([])
    setIsRetrieve(false)
  }
  const [elemets, setElemets] = useState({})
  const [entityMap, setEntityMap] = useState({})
  const [subgroupNameMap, setSubgroupNameMap] = useState({})
  const [plantNameMap, setPlantNameMap] = useState({})
  const [activeKey, setActiveKey] = useState('criteria')
  const [basicOptions, setBasicOptions] = useState(
    R.compose(
      R.fromPairs,
      R.map(e => [e, true])
    )(recordTypeOrder)
  )

  useEffect(
    _ => {
      wind2AllSubgroup(targetInfo).fork(setError, d => {
        setSubgroupList(d)
        setSubgroupMap(
          R.compose(
            R.fromPairs,
            R.map(({ entityId, plantId, subgroupId, subgroupName }) => [
              `${entityId}-${plantId}-${subgroupId}`,
              { entityId, plantId, subGroupId: subgroupId, subgroupName },
            ])
          )(d)
        )
        const nameMAP = R.compose(
          R.fromPairs,
          R.map(({ entityId, plantId, subgroupId, subgroupName }) => [
            subgroupId,
            subgroupName,
          ])
        )(d)
        setSubgroupNameMap(nameMAP)
      })

      getWind2Entity(targetInfo).fork(setError, data => {
        const mp = R.compose(
          R.fromPairs,
          R.map(d => [d.entityId, d.entityName])
        )(data)
        setEntityMap(mp)
      })

      wind2ReportGetElements(targetInfo).fork(setError, elemets =>
        setElemets(elemets)
      )
      wind2AllPlant(targetInfo).fork(setError, data => {
        const mp = R.compose(
          R.fromPairs,
          R.map(d => [d.plantId, d.plantName])
        )(data)

        setPlantNameMap(mp)
      })
      initWind2TemplateGroups()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setError, targetInfo]
  )
  const [isRetrieve, setIsRetrieve] = useState(false)

  const onRetrieve = _ => {
    if (subGroupsData.selected.length <= 0) {
      message.info('Please Select Subgroup')
      return
    }
    const req = {
      fromMonth: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      toMonth: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      subGroups: subGroupsData.selected.map(d => subgroupMap[d]),
      includeRawData: basicOptions.RAW,
    }
    setSpinning(true)
    wind2Report(targetInfo)(req).fork(setError, data => {
      const groupedData = Object.groupBy(data, e => e.recordType)
      setData(recordTypeOrder.map(rt => groupedData[rt] || []).flat())
      setIsRetrieve(true)
      setSpinning(false)
      setActiveKey('data')
    })
  }
  const STR_TYPE = 'str'
  const NUM_TYPE = 'num'

  const getColumns = useCallback(
    _ => {
      const Tablecolumn = [
        {
          title: 'Roll-up',
          dataIndex: 'recordType',
          key: 'recordType',
          width: 140,
          align: 'left',
          fixed: 'left',
          render: text => typeMap[text],
          type: STR_TYPE,
        },
        {
          title: 'Month',
          dataIndex: 'month',
          key: 'month',
          align: 'center',
          width: 100,
          fixed: 'left',
          type: STR_TYPE,
          render: (text, record) => {
            const { year, month } = record
            let str = ''
            if (year) str += year
            if (year && month) str += '-'
            if (month) str += month

            return str
          },
        },
        {
          title: 'Plant',
          dataIndex: 'plantId',
          key: 'plantId',
          width: 140,
          align: 'left',
          fixed: 'left',
          render: (text, record) => {
            return plantNameMap[record.plantId] || record.plantId
          },
        },
        {
          title: 'Subgroup',
          dataIndex: 'subgroupId',
          key: 'subgroupId',
          width: 140,
          align: 'left',
          fixed: 'left',
          render: (text, record) => {
            return subgroupNameMap[record.subgroupId] || record.subgroupId
          },
        },
      ]

      const { inputDesc = [], outputDesc = [] } = elemets

      const inputelementsColumns = sortByProp('elementDescription')(
        calcElementsData.selected.includes('ALL')
          ? inputDesc
          : inputDesc.filter(ie =>
              calcElementsData.selected.includes(ie.elementId)
            )
      ).map(d => ({
        title: calcElementsData.abbreviatedForm
          ? d.elementId
          : d.elementDescription,
        elementInfo: d,
        dataIndex: d.elementId,
        key: d.elementId,
        width: 200,
        align: 'right',
        // type:numValues[d.elementId] ? NUM_TYPE :STR_TYPE,
        render: (text, record) => {
          const { numValues, strValues } = record

          let val = numValues[d.elementId]
          if (val)
            val = numeral(val).format(
              '000,000.' +
                Array.from({ length: d.roundingDecimal || 3 }, _ => '0').join(
                  ''
                )
            )
          return val || strValues[d.elementId]
        },
      }))

      const outputElementsColumns = sortByProp('elementDescription')(
        calcElementsData.selected.includes('ALL')
          ? outputDesc
          : outputDesc.filter(ie =>
              calcElementsData.selected.includes(ie.elementId)
            )
      ).map(d => ({
        title: calcElementsData.abbreviatedForm
          ? d.elementId
          : d.elementDescription,
        elementInfo: d,
        dataIndex: d.elementId,
        key: d.elementId,
        width: 200,
        align: 'right',
        type: NUM_TYPE,
        render: (text, record) => {
          const { numValues, strValues } = record

          let val = numValues[d.elementId]
          if (val)
            val = numeral(val).format(
              '000,000.' +
                Array.from({ length: d.roundingDecimal || 3 }, _ => '0').join(
                  ''
                )
            )
          return val || strValues[d.elementId]
        },
      }))
      return [...Tablecolumn, ...inputelementsColumns, ...outputElementsColumns]
    },

    [
      calcElementsData.abbreviatedForm,
      calcElementsData.selected,
      elemets,
      plantNameMap,
      subgroupNameMap,
    ]
  )

  const handleExport = e => {
    if (e.key === 'pdf') exportPDFData()
    else if (e.key === 'xls') exportXLSXData()
  }

  const criteriaDataforExcel = () => {
    const sd = `${selectedDateRangePicker[0].format('MMM-YYYY')}`
    const ed = `${selectedDateRangePicker[1].format('MMM-YYYY')}`
    const forGroups = subGroupsData.selected
      .map(g => subgroupMap[g].subgroupName)
      .map((e, idx) => ({ name: idx === 0 ? 'Sub Groups' : '', value: e }))
    const rollups = Object.keys(basicOptions)
      .filter(k => basicOptions[k])
      .map((e, idx) => ({ name: idx === 0 ? 'Rollup' : '', value: e }))
    const calcElements = getColumns()
      .filter(
        c =>
          ![
            'recordType',
            'year',
            'month',
            'entityId',
            'plantId',
            'subgroupId',
          ].includes(c.key)
      )
      .map((e, idx) => ({
        name: idx === 0 ? 'Filtered Elements' : '',
        value: e.key + ' - ' + e.title,
      }))

    return [
      { name: 'Criteria' },
      {},
      { name: 'From', value: sd },
      { name: 'To', value: ed },
      {},
      ...forGroups,
      {},
      ...rollups,
      {},
      ...calcElements,
    ]
  }

  const exportXLSXData = async _ => {
    const columns = getColumns().map(col => {
      const colWidth = col.title.length * 2
      return {
        header: col.title,
        display: col.title,
        key: col.dataIndex,
        width: (col.width && col.width / 10) || (colWidth > 10 ? colWidth : 10),
        type: 'str',
        // displayFormat: col.excelFormat || col.displayFormat,
      }
    })

    const criteriaCols = [
      {
        header: '',
        display: '',
        key: 'name',
        width: 18,
        type: 'str',
      },
      {
        header: '',
        display: '',
        key: 'value',
        width: 70,
        type: 'str',
      },
    ]

    const xlsxData = toXlsxData(
      data
        .filter(d => basicOptions[d.recordType])
        .map(({ numValues, strValues, ...rest }) => ({
          ...rest,
          ...numValues,
          ...strValues,
        })),
      getColumns().map(col => ({
        ...col,
        display: col.title,
        id: col.dataIndex,
        type: 'num',
        dataType: 'NUMBER',
        dataFormatter: ({ value, rowData }) => {
          if (col.dataIndex === 'recordType') return typeMap[value]
          const val = numeral(value)
          // if (val.render) return val.render(value, rowData)

          if (col.dataIndex === 'entityId')
            return entityMap[rowData.entityId] || rowData.entityId
          if (col.dataIndex === 'plantId')
            return plantNameMap[rowData.plantId] || rowData.plantId
          if (col.dataIndex === 'subgroupId')
            return subgroupNameMap[rowData.subgroupId] || rowData.subgroupId
          if (col.dataIndex === 'month') {
            const { year, month } = rowData
            let str = ''
            if (year) str += year
            if (year && month) str += '-'
            if (month) str += month

            return str
          }

          if (col.type === STR_TYPE) return value
          if (isNaN(val.value())) return value
          return val.value() // retain all precision
          // return val.value()
          // return col.render ? numeral(value).format('000,000.000') : value
        },
      }))
    )
    // return
    const worksheets = [
      {
        name: 'Data',
        columns,
        data: xlsxData,
        metaInfo: [],
      },
      {
        name: 'Criteria',
        columns: criteriaCols,
        data: criteriaDataforExcel(),
        metaInfo: [],
      },
    ]

    const fileName = title
    const userId = 'GADS'

    const fileBlob = await writeToExcel(worksheets, userId)
    saveAs(fileBlob, fileName)
  }

  const exportPDFData = _ => {
    const sd = `${selectedDateRangePicker[0].format('MMM-YYYY')}`
    const ed = `${selectedDateRangePicker[1].format('MMM-YYYY')}`
    const forGroups = subGroupsData.selected.map(
      g => subgroupMap[g].subgroupName
    )
    const fileNAme = title + '.pdf'
    // ' [' +
    // forGroups.join(',') +
    // '] [' +
    // sd +
    // ' to ' +
    // ed +
    // ']' +
    // '.pdf'

    const req = {
      data: data
        .filter(d => basicOptions[d.recordType])
        .map(d => ({ ...d, recordType: typeMap[d.recordType] })),
      calcElements: getColumns()
        .filter(
          c =>
            ![
              'recordType',
              'year',
              'month',
              'entityId',
              'plantId',
              'subgroupId',
            ].includes(c.key)
        )
        .map(e => e.elementInfo),
      abbreviatedForm: calcElementsData.abbreviatedForm,
      from: sd,
      to: ed,
      subGroups: forGroups,
      rollups: Object.keys(basicOptions).filter(k => basicOptions[k]),
    }

    setSpinning(true)
    wind2ReportExportBlob(targetInfo)(req, {}, fileNAme)(_ =>
      setSpinning(false)
    )
  }

  const setSelectedValue = (value = [], currentState, setterFn) => {
    currentState.selected = value
    setterFn({ ...currentState })
  }

  const setPropertyValue = (name, value, currentState, setterFn) => {
    currentState[name] = value
    setterFn({ ...currentState })
  }

  const initWind2TemplateGroups = useCallback(
    latFunc => {
      const byGroupName = R.groupBy(list => list.templateName)
      getWind2TemplateGroups(targetInfo)({
        type: ['SUBGROUP', 'CALC_ELEMENT'],
      }).fork(setError, d => {
        setPropertyValue(
          'availableGroups',
          byGroupName(d.filter(e => e.type === 'SUBGROUP')),
          subGroupsData,
          setSubGroupsData
        )
        setPropertyValue(
          'availableGroups',
          byGroupName(d.filter(e => e.type === 'CALC_ELEMENT')),
          calcElementsData,
          setCalcElementsData
        )
        latFunc && latFunc()
      })
    },
    [targetInfo, setError, subGroupsData, calcElementsData]
  )

  const saveDataGroup = (type, groupName, selectedItems) => {
    saveWind2TemplateGroup(targetInfo)(
      selectedItems.map((ident, i) => ({
        templateName: groupName,
        ident,
        type,
        // username: 'admin',
        seq: i + 1,
      }))
    ).fork(setError, () => {
      message.success(`Changes to group "${groupName}" saved successfully`)
      initWind2TemplateGroups()
    })
  }

  const deleteItemGroup = (groupName, type) => {
    Modal.confirm({
      title: 'Are you sure, you want to delete this Group?',
      content: groupName,
      onOk() {
        deleteWind2TemplateGroup(targetInfo)({ group: groupName, type }).fork(
          setError,
          _ => {
            message.success(`Group "${groupName}" deleted successfully`)

            const latFunc = _ => {
              switch (type) {
                case 'SUBGROUP': {
                  setSelectedValue([], subGroupsData, setSubGroupsData)
                  setPropertyValue(
                    'currentGroup',
                    'Custom',
                    subGroupsData,
                    setSubGroupsData
                  )
                  break
                }
                case 'CALC_ELEMENT': {
                  setSelectedValue([], calcElementsData, setCalcElementsData)
                  setPropertyValue(
                    'currentGroup',
                    'Custom',
                    calcElementsData,
                    setCalcElementsData
                  )
                  break
                }
                default:
              }
            }
            initWind2TemplateGroups(latFunc)
          }
        )
      },
      onCancel() {},
    })
  }

  return (
    <div>
      <CriteriaRow style={{ justifyContent: 'center' }}>
        <Title>{title}</Title>
        <Filler />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 100px 100px auto',
            gap: 50,
          }}
        >
          <div />
          <Button
            type="primary"
            onClick={_ => handleExport({ key: 'pdf' })}
            disabled={!isRetrieve}
          >
            PDF
          </Button>
          <Button
            type="primary"
            onClick={_ => handleExport({ key: 'xls' })}
            disabled={!isRetrieve}
          >
            Excel
          </Button>
          <div />
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={180}>
        {({ height }) => (
          <Content style={{ height: height - 50 }}>
            <Tabs activeKey={activeKey} onChange={setActiveKey}>
              <Tabs.TabPane title="Criteria" key="criteria" tab="Criteria">
                <div>
                  <Row gutter={24}>
                    <Col span={8}>
                      <LabelWithCustomSelect
                        type="SUBGROUP"
                        label="1. Sub Groups"
                        state={subGroupsData}
                        setterFn={setSubGroupsData}
                        setPropertyValue={setPropertyValue}
                        setSelectedValue={setSelectedValue}
                        saveDataGroup={saveDataGroup}
                        deleteItemGroup={deleteItemGroup}
                        onChange={onChange}
                      />
                      <Select
                        className="multiple-select-big"
                        value={subGroupsData.selected}
                        onChange={e => {
                          setSelectedValue(e, subGroupsData, setSubGroupsData)
                          onChange()
                        }}
                        style={{ width: '100%' }}
                        placeholder="Select"
                        mode="multiple"
                      >
                        {sortByProp('subgroupName')(subgroupList).map(d => (
                          <Select.Option
                            key={`${d.entityId}-${d.plantId}-${d.subgroupId}`}
                          >
                            {d.subgroupName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Col>
                    <Col span={6}>
                      <Label
                        style={{
                          fontWeight: 800,
                          marginLeft: 5,
                          marginTop: 'auto',
                          display: 'grid',
                          alignContent: 'center',
                          height: '100%',
                        }}
                      >
                        2. Date Range
                      </Label>
                      <DatePicker.RangePicker
                        style={{ marginBottom: '10px' }}
                        allowClear={false}
                        format="MMM-YYYY"
                        mode={['month', 'month']}
                        value={selectedDateRangePicker}
                        onChange={d => {
                          setSelectedDateRagePicker([
                            d[0].startOf('month'),
                            d[1].endOf('month'),
                          ])
                          onChange()
                        }}
                        onPanelChange={d => {
                          setSelectedDateRagePicker([
                            d[0].startOf('month'),
                            d[1].endOf('month'),
                          ])
                          onChange()
                        }}
                      />
                    </Col>
                    <Col span={10} style={{ display: 'flex' }}>
                      <div style={{ height: '26px' }} />
                      <Filler />
                      <Button
                        loading={spinning}
                        onClick={onRetrieve}
                        style={{ marginLeft: '10px', width: '150px' }}
                        type="primary"
                        icon="database"
                      >
                        Retrieve
                      </Button>
                    </Col>
                  </Row>
                  <Divider>Filter Options</Divider>
                  <Row gutter={24}>
                    <Col span={15}>
                      <LabelWithCustomSelect
                        type="CALC_ELEMENT"
                        label="3. Elements"
                        state={calcElementsData}
                        setterFn={setCalcElementsData}
                        setPropertyValue={setPropertyValue}
                        setSelectedValue={setSelectedValue}
                        saveDataGroup={saveDataGroup}
                        deleteItemGroup={deleteItemGroup}
                      />
                      <Select
                        mode="multiple"
                        className="multiple-select-big"
                        placeholder="Select Elements"
                        value={calcElementsData.selected}
                        onChange={e => {
                          const prevSelected = calcElementsData.selected
                          const currSelected = prevSelected.includes('ALL')
                            ? e.includes('ALL')
                              ? e.filter(e => e !== 'ALL')
                              : e
                            : e.includes('ALL')
                            ? ['ALL']
                            : e

                          setSelectedValue(
                            currSelected,
                            calcElementsData,
                            setCalcElementsData
                          )
                        }}
                        style={{ minWidth: '100%' }}
                      >
                        <Select.Option key="ALL" value="ALL">
                          ALL
                        </Select.Option>
                        {sortByProp('elementDescription')([
                          ...((elemets || {}).inputDesc || []),
                          ...((elemets || {}).outputDesc || []),
                        ]).map(i => (
                          <Select.Option key={i.elementId} value={i.elementId}>
                            {i.elementId} - {i.elementDescription}
                          </Select.Option>
                        ))}
                      </Select>
                      <Switch
                        style={{ marginRight: '10px' }}
                        checked={calcElementsData.abbreviatedForm}
                        onChange={checked =>
                          setPropertyValue(
                            'abbreviatedForm',
                            checked,
                            calcElementsData,
                            setCalcElementsData
                          )
                        }
                      />
                      <Label inline>show abbreviated form of element</Label>
                    </Col>
                    <Col span={6}>
                      <Label
                        style={{
                          fontWeight: 800,
                          marginLeft: 5,
                          marginTop: 'auto',
                          display: 'grid',
                          alignContent: 'center',
                          height: '100%',
                        }}
                      >
                        4. Rollup
                      </Label>
                      {recordTypeOrder.map(rt => (
                        <div key={rt} style={{ marginBottom: '10px' }}>
                          <Switch
                            style={{ marginRight: '10px' }}
                            // checkedChildren="hide"
                            // unCheckedChildren="show"
                            checked={basicOptions[rt]}
                            onChange={checked =>
                              setBasicOptions(prev => ({
                                ...prev,
                                [rt]: checked,
                              }))
                            }
                          />
                          <Label inline>
                            {rt === 'RAW' ? 'raw' : typeMap[rt]}
                          </Label>
                        </div>
                      ))}
                    </Col>
                    <Col span={3} style={{ display: 'flex' }}>
                      <Filler />
                    </Col>
                  </Row>
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane title="Data" key="data" tab="Data">
                <Table
                  columns={getColumns()}
                  dataSource={data.filter(d => basicOptions[d.recordType])}
                  scroll={{ y: height - 200, x: 1000 }}
                  rowKey={d => d.uuid}
                  // bordered
                />
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2Report)
